import React from "react";
import { usePatientDocumentsQuery } from "../../../../../api/patientDocuments/usePatientDocumentsQuery";
import { uiNotification } from "../../../../../services/UINotificationService";
import { getPathParams } from "../utilities";

export var withDocumentTypes = (Component) => (props) => {
  var { patientId } = getPathParams();

  var { data } = usePatientDocumentsQuery({
    payload: {
      pageSize: 15,
      patientId,
    },
    options: {
      staleTime: 0,
      cacheTime: 0,
      keepPreviousData: true,
      onError: () => {
        uiNotification.error(
          "Unable to fetch document types. Please try again later.",
        );
      },
    },
  });

  return (
    <Component {...props} documentTypes={data?.pages?.[0]?.docTypes || []} />
  );
};
